export const personalData = [
    {
        label : "Name",
        value : "Kerry Space"
    },
    {
        label : "Age",
        value : "26"
    },
    {
        label : "Address",
        value : "Sweden"
    },
    {
        label : "Email",
        value : "Kerry9510@protonmail.com"
    }
    
]